__turbopack_context__.v({
  "center": "WebV2SectionHeader-module-scss-module__1OfZHa__center",
  "description": "WebV2SectionHeader-module-scss-module__1OfZHa__description",
  "eyebrow": "WebV2SectionHeader-module-scss-module__1OfZHa__eyebrow",
  "header": "WebV2SectionHeader-module-scss-module__1OfZHa__header",
  "left": "WebV2SectionHeader-module-scss-module__1OfZHa__left",
  "title": "WebV2SectionHeader-module-scss-module__1OfZHa__title",
});
